import React from 'react';

import PageHeader from '../components/header/page';
import Maps from '../components/maps';
import Address from '../components/address';

const ContactPage = props =>
  (<main>
    <PageHeader nobottom>
      Hier können Sie<br/> uns finden!
    </PageHeader>
    <section className="container-custom">
      <Address/>
    </section>
    <Maps/>
  </main>);

export default ContactPage;


// WEBPACK FOOTER //
// ./src/pages/contact.js